import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { useEffect } from 'react';
import { useState } from 'react';
import { GenerateNumbers } from '../../../lib/helpers/ArrayHelper';
import ItemCollectionDateView from '../item/ItemCollectionDateView';
import { P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  affected: number;
  confirm?: (force: boolean, date?: Date) => void;
  cancel?: () => void;
}

export default function ApplyPreferredCollectionDate(props: props) {
  const limit = 7;
  const [date, setDate] = useState<Date>(null);
  const [force, setForce] = useState(true);
  const [options, setOptions] = useState<{ Date: Date }[]>([]);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useEffect(() => {
    const dateOptions = GenerateNumbers(1, limit + 20)
      .map((x) => {
        const d = new Date(new Date().toDateString());
        d.setDate(d.getDate() + x);
        if ([0, 6].includes(d.getDay())) {
          return null;
        }
        return { Date: d };
      })
      .filter((x) => !!x)
      .slice(0, limit);

    setOptions(dateOptions);
    setDate(dateOptions[0].Date);
  }, []);

  if (options.length === 0 || !date) {
    return null;
  }

  return (
    <P2GBox textAlign="center">
      <P2GBox mt={2}>
        <P2GBox pt={2}>
          <ItemCollectionDateView
            textAlign="left"
            limit={limit}
            size="large"
            dates={options}
            selected={date}
            setDate={setDate}
          />
        </P2GBox>

        <P2GBox mt={2} textAlign="left">
          <P2GCheckBoxLegacy
            id="Force"
            label={
              <P2GText variant="body2">
                {t('REPLACE_COLLECTION_DATES_INPUT_LABEL', {
                  defaultValue: 'Replace collection dates on all selected items.'
                })}
              </P2GText>
            }
            onChange={setForce}
            checked={force}
            labelPlacement="end"
            variant="primary"
            error={false}
          />
        </P2GBox>

        <P2GBox mt={2}>
          <P2GGrid container spacing={2}>
            {props.confirm && (
              <P2GGrid item>
                <P2GButton onClick={() => props.confirm(force, date)}>
                  {t('SAVE_BUTTON', { defaultValue: 'Save' })}
                </P2GButton>
              </P2GGrid>
            )}
            {props.cancel && (
              <P2GGrid item>
                <P2GButton variant="primary" onClick={props.cancel}>
                  {t('CANCEL_BUTTON', { defaultValue: 'Cancel' })}
                </P2GButton>
              </P2GGrid>
            )}
          </P2GGrid>
        </P2GBox>
      </P2GBox>
    </P2GBox>
  );
}
